var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"btn-line",attrs:{"href":("https://social-plugins.line.me/lineit/share?url=" + (_vm.domain +
        _vm.currentPath)),"target":"_blank"}},[_c('span',{staticClass:"d-block",staticStyle:{"transform":"scale(0.8)"}},[_vm._v(" LINE ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }